"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.deepSnakeToCamelCase = void 0;
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var mapKeys_1 = __importDefault(require("lodash/mapKeys"));
var camelCase_1 = __importDefault(require("lodash/camelCase"));
function deepSnakeToCamelCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map(function (v) { return deepSnakeToCamelCase(v); });
    }
    else if (obj && typeof obj === 'object') {
        return (0, mapValues_1["default"])((0, mapKeys_1["default"])(obj, function (_, key) { return (0, camelCase_1["default"])(key); }), function (value) { return deepSnakeToCamelCase(value); });
    }
    return obj;
}
exports.deepSnakeToCamelCase = deepSnakeToCamelCase;
